export default __webpack_public_path__ + "static/media/BC_441_BC_07210_tn.9445a935.jpg";